import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Main.vue";
import RequestEmails from "../views/RequestEmails.vue";
import CatchSession from "../views/CatchSession.vue";
import RegisterApp from "../views/RegisterApp.vue";
import PageNotFound from "../components/PageNotFound.vue";
import store from "@/store";
import { ROUTES } from "@/constants/routes";

import AppCard from "../components/AppCard.vue";
import ProfilePage from "../components/ProfilePage.vue";
import DeSappDetails from "../components/DeSappDetails.vue";
import Landing from "../views/Landing.vue";
import SessionExpired from "../views/SessionExpired.vue";
import qs from "qs";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: ROUTES.LANDING.path,
    name: ROUTES.LANDING.name,
    component: Landing,
  },
  {
    path: ROUTES.HOME.path,
    name: ROUTES.HOME.name,
    component: Home,
  },
  {
    path: ROUTES.REQUEST_EMAILS.path,
    name: ROUTES.REQUEST_EMAILS.name,
    component: RequestEmails,
  },
  {
    path: ROUTES.CATCH_SESSION.path,
    name: ROUTES.CATCH_SESSION.name,
    component: CatchSession,
  },
  {
    path: ROUTES.REGISTER_APP.path,
    name: ROUTES.REGISTER_APP.name,
    component: RegisterApp,
    beforeEnter(to, from, next) {
      if (!store.getters.getSessionId) next(ROUTES.HOME.path);
      else next();
    },
  },
  {
    path: ROUTES.DETAILS_APP.path,
    name: ROUTES.DETAILS_APP.name,
    component: DeSappDetails,
  },
  {
    path: ROUTES.SEARCH.path,
    name: ROUTES.SEARCH.name,
    component: Home,
    props: true,
  },
  {
    path:ROUTES.PROFILE.path,
    name:ROUTES.PROFILE.name,
    component:ProfilePage,
    beforeEnter(to, from, next) {
      if (!store.getters.getSessionId) next(ROUTES.HOME.path);
      else next();
    },
  },
  {
    path:ROUTES.SESSION_EXPIRED.path,
    name:ROUTES.SESSION_EXPIRED.name,
    component:SessionExpired,
  },
  { path: "*", component: PageNotFound },
];

const router = new VueRouter({
  mode: "history",
  stringifyQuery: (query) => {
    const result = qs.stringify(query, { encode: false });
    return result ? "?" + result : "";
  },
  base: process.env.BASE_URL,
  routes,
});

export default router;
